import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler
} from "react-native";

import EmptyView from "../../../customviews/empty/EmptyView";

import DialogConnectionCustomize from "../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../customviews/HMActionBar";
import i18n from "../../../I18n/i18n";
import store from "../../../redux/store";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";
import AdapterListOperatorFireApply from "./adapter/AdapterListOperatorFireApply";
import {moderateScale} from "../../../tools/Scaling";
import Colors from "../../../tools/Colors";
import HMTextView from "../../../customviews/HMTextView";


let container = null;
export default class ListMessageHistoryOperatorFireScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,
            list: [],
            empty: false


        };
        container = this;

    }

    state = {
        show: false
    };

    componentWillReceiveProps(propss) {


    }

    async componentDidMount() {

        let data = await AsyngStorageClass.getASyng(global.IdCity + "ListMessageHistoryOperatorFireScreen")

        this.setState({
            list: data && data.length > 0 ? data : [],
            empty: !(data && data.length > 0)
        })

    }

    componentWillUnmount() {


    }


    render() {
        // let {item, data} = this.props.route.params
        let myLocation = store.getState().reducerSplashGetAllData.Location;

        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        //let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1,}}>



                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            menu={true}
                            back={true}

                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListOperatorFireApply.title')}
                            text={i18n.t('constant.MessageRecords')}
                            //text={(data.name ? data.name : (data.title ? data.title : ''))}
                            //  text={this.state.arraySelected.length}


                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        <View style={{flex: 1}}>
                            <TouchableOpacity
                                onPress={() => {
                                    Alert.alert(
                                        i18n.t('constant.message'),
                                        i18n.t('constant.AreYouClearHistory'),
                                        [
                                            // {text: 'Ask me later', onPress: () => {}},
                                            {
                                                text: i18n.t('constant.No'), onPress: () => {


                                                }, style: 'cancel'
                                            },
                                            {
                                                text: i18n.t('constant.Yes'), onPress: async () => {

                                                    await AsyngStorageClass.setAsyng(global.IdCity + "ListMessageHistoryOperatorFireScreen", [])
                                                    this.setState({list: [], empty: true})
                                                    //, NavigationService.resetTo('SplashScreen')
                                                }
                                            },
                                        ],
                                        {cancelable: true}
                                    )

                                }}
                                style={{
                                    width: '96%',
                                    height: moderateScale(33),
                                    backgroundColor: Colors.colorSecondPrimary,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    alignSelf: 'center',
                                    flexDirection: 'row',
                                    marginTop: moderateScale(4),
                                    marginHorizontal: moderateScale(4),
                                    borderRadius: moderateScale(8)
                                }}>


                                <HMTextView
                                    numberOfLines={1}
                                    type={"bold"}
                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                    text={i18n.t('constant.ClearHistory')}
                                    style={{
                                        fontSize: moderateScale(12),
                                        color: Colors.white,
                                        marginHorizontal: moderateScale(4)
                                        //  marginTop: moderateScale(4),
                                        //  textAlign: "right",
                                    }}/>


                            </TouchableOpacity>
                            <EmptyView empty={this.state.empty}/>
                            <FlatList
                                data={this.state.list}
                                renderItem={this.renderItem}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() =>
                                    null}

                            />
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }

                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <AdapterListOperatorFireApply
            offline={true}
            item={item}
            listTask={this.state.list}
            //item_parent={this.props.route.params.item}
            index={index} hiddenModal={this.hiddenModal}/>;
    }

    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }


}
